import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
// import Loader from "../../Components/Loader";
// import GuestGuard from "../guards/GuestGuard";
// import AuthGuard from "../guards/AuthGuard";
// import SuperAdminGuard from "../guards/SuperAdminGuard";
// import AdminLayout from "../pages/Admin/Layout/AdminLayout";
import WebsiteLayout from "../Pages/Website/Layout/Layout";
import Loader from "../Components/Loader";
import AdminLayout from "../Pages/Admin/Layout/AdminLayout";
import GuestGuard from "../Guards/GuestGuard";
import AuthGuard from "../Guards/AuthGaurd";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    // {
    //   path: "/app/about-us",
    //   element: (
    //     <GuestGuard>
    //       <AboutUs />
    //     </GuestGuard>
    //   ),
    // },
    // {
    //   path: "/app/contact-us",
    //   element: (
    //     <GuestGuard>
    //       <ContactUs />
    //     </GuestGuard>
    //   ),
    // },
    {
      path: "/app/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/app/terms-and-conditions",
      element: <TermsAndConditions />,
    },
    // {
    //   path: "/app/cancellation-and-refund",
    //   element: (
    //     <GuestGuard>
    //       <CancellationRefund />
    //     </GuestGuard>
    //   ),
    // },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "/reset-password/:token",
      element: <ResetPassword />,
    },
    {
      path: "/",
      element: <WebsiteLayout />,
      children: [
        {
          path: "/",
          element: <LandingPage />,
        },

        {
          path: "/about-us",
          element: <AboutUs />,
        },
        {
          path: "/blog",
          element: <Blog />,
        },
        {
          path: "/blog/:slug",
          element: <BlogPage />,
        },
        {
          path: "/help-center",
          element: <HelpCenter />,
        },
        {
          path: "/whatsapp-guidelines",
          element: <WhatsAppGuidelines />,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "/terms-conditions",
          element: <TermsAndConditions />,
        },
      ],
    },
    {
      path: "/admin",
      element: (
        <AuthGuard>
          <AdminLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "/admin/dashboard",
          element: (
            <AuthGuard>
              <Dashboard />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/contacts",
          element: (
            <AuthGuard>
              <Contacts />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-contact",
          element: (
            <AuthGuard>
              <AddContact />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-contact",
          element: (
            <AuthGuard>
              <EditContact />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/users",
          element: (
            <AuthGuard>
              <Users />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/user-profile",
          element: (
            <AuthGuard>
              <UserProfile />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-user",
          element: (
            <AuthGuard>
              <AddUser />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-user",
          element: (
            <AuthGuard>
              <EditUser />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/pricing",
          element: (
            <AuthGuard>
              <Pricing />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/browse-plans",
          element: (
            <AuthGuard>
              <BrowsePlans />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/pricing-details",
          element: (
            <AuthGuard>
              <PricingDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-pricing",
          element: (
            <AuthGuard>
              <AddPricing />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-pricing",
          element: (
            <AuthGuard>
              <EditPricing />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/templates",
          element: (
            <AuthGuard>
              <Templates />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/template-details",
          element: (
            <AuthGuard>
              <TemplateDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-template",
          element: (
            <AuthGuard>
              <AddTemplate />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-template",
          element: (
            <AuthGuard>
              <EditTemplate />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/campaigns",
          element: (
            <AuthGuard>
              <Campaigns />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/campaign-details",
          element: (
            <AuthGuard>
              <CampaignDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-campaign",
          element: (
            <AuthGuard>
              <AddCampaign />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-campaign",
          element: (
            <AuthGuard>
              <EditCampaign />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/bookings",
          element: (
            <AuthGuard>
              <Bookings />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/booking-details",
          element: (
            <AuthGuard>
              <BookingDetails />
            </AuthGuard>
          ),
        },

        {
          path: "/admin/add-booking",
          element: (
            <AuthGuard>
              <AddBooking />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-booking",
          element: (
            <AuthGuard>
              <EditBooking />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/chats",
          element: (
            <AuthGuard>
              <Inbox />
            </AuthGuard>
          ),
        },

        {
          path: "/admin/bots",
          element: (
            <AuthGuard>
              <Bots />
            </AuthGuard>
          ),
        },

        {
          path: "/admin/add-bot",
          element: (
            <AuthGuard>
              <AddBot />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-bot",
          element: (
            <AuthGuard>
              <EditBot />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/bot-details",
          element: (
            <AuthGuard>
              <BotDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/addons",
          element: (
            <AuthGuard>
              <Addons />
            </AuthGuard>
          ),
        },

        {
          path: "/admin/add-addon",
          element: (
            <AuthGuard>
              <AddAddon />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-addon",
          element: (
            <AuthGuard>
              <EditAddon />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/addon-details",
          element: (
            <AuthGuard>
              <AddonDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/billing",
          element: (
            <AuthGuard>
              <Billing />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/billing-details",
          element: (
            <AuthGuard>
              <BillingDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/bot-analytics",
          element: (
            <AuthGuard>
              <BotAnalytics />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/subscriptions",
          element: (
            <AuthGuard>
              <Subscriptions />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/subscription-details",
          element: (
            <AuthGuard>
              <SubscriptionDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/user-subscription",
          element: (
            <AuthGuard>
              <UserSubscription />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/user-addons",
          element: (
            <AuthGuard>
              <UserAddons />
            </AuthGuard>
          ),
        },

        {
          path: "/admin/browse-addons",
          element: (
            <AuthGuard>
              <BrowseAddons />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-user-addon",
          element: (
            <AuthGuard>
              <EditUserAddons />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/user-addon-details",
          element: (
            <AuthGuard>
              <UserAddonDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/system-logs",
          element: (
            <AuthGuard>
              <SystemLogs />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/system-log-details",
          element: (
            <AuthGuard>
              <SystemLogDetails />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/system-log-stats",
          element: (
            <AuthGuard>
              <SystemLogStats />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/whatsapp-connect",
          element: (
            <AuthGuard>
              <WhatsAppConnect />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/settings",
          element: (
            <AuthGuard>
              <Settings />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/enquiries",
          element: (
            <AuthGuard>
              <Enquiries />
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
  ]);
}

const NotFound = Loadable(lazy(() => import("../Pages/404/Page404")));

//=====================WEBSITE===============

const LandingPage = Loadable(
  lazy(() => import("../Pages/Website/LandingPage/LandingPage"))
);
const Login = Loadable(lazy(() => import("../Pages/Website/Auth/LoginForm")));
const Register = Loadable(
  lazy(() => import("../Pages/Website/Auth/RegisterForm"))
);
const ForgotPassword = Loadable(
  lazy(() => import("../Pages/Website/Auth/ForgotPasswordForm"))
);
// const ChangePassword = Loadable(
//   lazy(() => import("../Pages/Website/Auth/ChangePasswordForm"))
// );
const ResetPassword = Loadable(
  lazy(() => import("../Pages/Website/Auth/ResetPasswordForm"))
);
const AboutUs = Loadable(
  lazy(() => import("../Pages/Website/AboutUs/AboutUs"))
);
const Blog = Loadable(lazy(() => import("../Pages/Website/Blog/Blog")));
const BlogPage = Loadable(lazy(() => import("../Pages/Website/Blog/BlogPost")));
const WhatsAppGuidelines = Loadable(
  lazy(() => import("../Pages/Website/WhatsAppGuidelines/WhatsAppGuidelines"))
);
const PrivacyPolicy = Loadable(
  lazy(() => import("../Pages/Website/PrivacyPolicy/PrivacyPolicy"))
);
const HelpCenter = Loadable(
  lazy(() => import("../Pages/Website/HelpCenter/HelpCenter"))
);
const TermsAndConditions = Loadable(
  lazy(() => import("../Pages/Website/TermsOfService/TermsOfService"))
);

//Admin
const Dashboard = Loadable(
  lazy(() => import("../Pages/Admin/Dashboard/Dashboard"))
);
const Contacts = Loadable(
  lazy(() => import("../Pages/Admin/Contacts/Contacts"))
);
const AddContact = Loadable(
  lazy(() => import("../Pages/Admin/Contacts/AddContact"))
);
const EditContact = Loadable(
  lazy(() => import("../Pages/Admin/Contacts/EditContact"))
);

const Users = Loadable(lazy(() => import("../Pages/Admin/Users/Users")));
const UserProfile = Loadable(
  lazy(() => import("../Pages/Admin/Users/UserProfile"))
);
const AddUser = Loadable(lazy(() => import("../Pages/Admin/Users/AddUser")));
const EditUser = Loadable(lazy(() => import("../Pages/Admin/Users/EditUser")));
const Pricing = Loadable(
  lazy(() => import("../Pages/Admin/Pricings/PricingPlans"))
);
const BrowsePlans = Loadable(
  lazy(() => import("../Pages/Admin/Pricings/BrowsePlans"))
);
const PricingDetails = Loadable(
  lazy(() => import("../Pages/Admin/Pricings/PricingDetails"))
);
const AddPricing = Loadable(
  lazy(() => import("../Pages/Admin/Pricings/AddPricing"))
);
const EditPricing = Loadable(
  lazy(() => import("../Pages/Admin/Pricings/EditPricing"))
);
const Templates = Loadable(
  lazy(() => import("../Pages/Admin/Templates/Templates"))
);
const TemplateDetails = Loadable(
  lazy(() => import("../Pages/Admin/Templates/TemplateDetails"))
);
const AddTemplate = Loadable(
  lazy(() => import("../Pages/Admin/Templates/AddTemplate"))
);
const EditTemplate = Loadable(
  lazy(() => import("../Pages/Admin/Templates/EditTemplate"))
);
const Campaigns = Loadable(
  lazy(() => import("../Pages/Admin/Campaigns/Campaigns"))
);
const CampaignDetails = Loadable(
  lazy(() => import("../Pages/Admin/Campaigns/CampaignDetails"))
);
const AddCampaign = Loadable(
  lazy(() => import("../Pages/Admin/Campaigns/AddCampaign"))
);
const EditCampaign = Loadable(
  lazy(() => import("../Pages/Admin/Campaigns/EditCampaign"))
);
const Bookings = Loadable(
  lazy(() => import("../Pages/Admin/Bookings/Bookings"))
);

const AddBooking = Loadable(
  lazy(() => import("../Pages/Admin/Bookings/AddBooking"))
);
const BookingDetails = Loadable(
  lazy(() => import("../Pages/Admin/Bookings/BookingDetails"))
);
const EditBooking = Loadable(
  lazy(() => import("../Pages/Admin/Bookings/EditBooking"))
);
const Bots = Loadable(lazy(() => import("../Pages/Admin/Bots/Bots")));

const AddBot = Loadable(lazy(() => import("../Pages/Admin/Bots/AddBot")));
const EditBot = Loadable(lazy(() => import("../Pages/Admin/Bots/EditBot")));
const BotDetails = Loadable(
  lazy(() => import("../Pages/Admin/Bots/BotDetails"))
);

const Addons = Loadable(lazy(() => import("../Pages/Admin/Addons/Addons")));
const AddAddon = Loadable(lazy(() => import("../Pages/Admin/Addons/AddAddon")));
const EditAddon = Loadable(
  lazy(() => import("../Pages/Admin/Addons/EditAddon"))
);
const AddonDetails = Loadable(
  lazy(() => import("../Pages/Admin/Addons/AddonDetails"))
);

const Billing = Loadable(lazy(() => import("../Pages/Admin/Billing/Billing")));
const BillingDetails = Loadable(
  lazy(() => import("../Pages/Admin/Billing/BillingDetails"))
);
const BotAnalytics = Loadable(
  lazy(() => import("../Pages/Admin/Bots/BotAnalytics"))
);
const Subscriptions = Loadable(
  lazy(() => import("../Pages/Admin/Subscriptions/Subscriptions"))
);
const SubscriptionDetails = Loadable(
  lazy(() => import("../Pages/Admin/Subscriptions/SubscriptionDetails"))
);
const UserSubscription = Loadable(
  lazy(() => import("../Pages/Admin/Subscriptions/UserSubscription"))
);
const UserAddons = Loadable(
  lazy(() => import("../Pages/Admin/UserAddons/UserAddons"))
);
const BrowseAddons = Loadable(
  lazy(() => import("../Pages/Admin/UserAddons/BrowseAddons"))
);
const EditUserAddons = Loadable(
  lazy(() => import("../Pages/Admin/UserAddons/EditUserAddon"))
);
const UserAddonDetails = Loadable(
  lazy(() => import("../Pages/Admin/UserAddons/UserAddonDetails"))
);
const SystemLogs = Loadable(
  lazy(() => import("../Pages/Admin/SystemLog/SystemLogs"))
);
const SystemLogDetails = Loadable(
  lazy(() => import("../Pages/Admin/SystemLog/SystemLogDetails"))
);
const SystemLogStats = Loadable(
  lazy(() => import("../Pages/Admin/SystemLog/SystemLogStats"))
);
const WhatsAppConnect = Loadable(
  lazy(() => import("../Pages/Admin/Whatsapp/WhatsAppConnect"))
);
const Settings = Loadable(
  lazy(() => import("../Pages/Admin/Settings/Settings"))
);

const Enquiries = Loadable(
  lazy(() => import("../Pages/Admin/Enquiries/Enquiries"))
);

const Inbox = Loadable(
  lazy(() => import("../Pages/Admin/Inbox/Inbox"))
);
